import { render, staticRenderFns } from "./LKPublicationsStorageFileIcon.vue?vue&type=template&id=1365a9b6&"
import script from "./LKPublicationsStorageFileIcon.vue?vue&type=script&lang=js&"
export * from "./LKPublicationsStorageFileIcon.vue?vue&type=script&lang=js&"
import style0 from "./LKPublicationsStorageFileIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports